var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2011_22596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.6875C2.84238 0.6875 0.6875 2.84238 0.6875 5.5C0.6875 8.15762 2.84238 10.3125 5.5 10.3125C8.15762 10.3125 10.3125 8.15762 10.3125 5.5C10.3125 2.84238 8.15762 0.6875 5.5 0.6875ZM5.5 9.49609C3.29355 9.49609 1.50391 7.70645 1.50391 5.5C1.50391 3.29355 3.29355 1.50391 5.5 1.50391C7.70645 1.50391 9.49609 3.29355 9.49609 5.5C9.49609 7.70645 7.70645 9.49609 5.5 9.49609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49609 1.50391C3.28965 1.50391 1.5 3.29355 1.5 5.5C1.5 7.70645 3.28965 9.49609 5.49609 9.49609C7.70254 9.49609 9.49219 7.70645 9.49219 5.5C9.49219 3.29355 7.70254 1.50391 5.49609 1.50391ZM7.39209 6.9792L7.08486 7.39814C7.07818 7.40727 7.06976 7.41498 7.06009 7.42084C7.05042 7.4267 7.03968 7.43059 7.0285 7.43228C7.01732 7.43398 7.00592 7.43345 6.99494 7.43073C6.98397 7.428 6.97364 7.42314 6.96455 7.41641L5.18779 6.1209C5.17672 6.11295 5.16773 6.10246 5.16156 6.09031C5.15539 6.07816 5.15223 6.0647 5.15234 6.05107V3.09375C5.15234 3.04648 5.19102 3.00781 5.23828 3.00781H5.75498C5.80225 3.00781 5.84092 3.04648 5.84092 3.09375V5.75244L7.37275 6.85996C7.41143 6.88682 7.42002 6.94053 7.39209 6.9792Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37666 6.85996L5.84482 5.75244V3.09375C5.84482 3.04648 5.80615 3.00781 5.75889 3.00781H5.24219C5.19492 3.00781 5.15625 3.04648 5.15625 3.09375V6.05107C5.15625 6.079 5.16914 6.10478 5.1917 6.1209L6.96846 7.41641C7.00713 7.44433 7.06084 7.43682 7.08877 7.39814L7.396 6.9792C7.42393 6.94053 7.41533 6.88682 7.37666 6.85996Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2011_22596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCircle);
export default __webpack_public_path__ + "static/media/clock-circle.f086fda45911efd9853f6e03e470368f.svg";
export { ForwardRef as ReactComponent };